import Player from '@FreeRider/Player/Player';

class Camera
{
    public x: number;
    public y: number;
    public zoom: number;
    public focus: Player | null

    private shakeDuration: number;

    constructor()
    {
        this.x = 0;
        this.y = 0;
        this.zoom = 0.7;
        this.focus = null;
        this.shakeDuration = 100;
    }

    public focusOnPlayer(player: Player)
    {
        this.focus = player;
    }

    public update()
    {
        if (this.focus)
        {
            this.panToPlayer(3);
        }
    }

    public panToPlayer(speed: number = 1)
    {
        if (this.focus)
        {
            var focus = this.focus.vehicle.getFocalPoint();

            if (focus)
            {
                var distX = focus.position.x - this.x;
                var distY = focus.position.y - this.y;

                var length = Math.sqrt(Math.pow(distX, 2) + Math.pow(distY, 2));

                if (length > 1500)
                {
                    speed = 1;
                }

                let positionX = focus.position.x;
                let positionY = focus.position.y;

                if( this.shakeDuration > 0 )
                {
                    positionX += (Math.random() * 25);
                    positionY += (Math.random() * 25);
                    this.shakeDuration--;
                }

                this.x += ((positionX - this.x) / speed);
                this.y += ((positionY - this.y) / speed);
            }
        }
    }

    public shake(duration: number)
    {
        this.shakeDuration = duration;
    }

    public reset()
    {
        this.shakeDuration = 0;
    }
}

export default Camera;